import { PremiumPurchasePlatformModule } from '@wix/premium-purchase-platform/@sdk';
import { FlowType, parseDomain } from '../..';
import { AddonProductFamiliesByDomainProductType, DEFAULT_DOMAIN_PRODUCT_TYPE, getDomainAddonsTypeId, getDomainProductTypeId } from '../../typing/domainProducts';
import { dynamicLoadApiQueries } from './dynamicLoadApiQueries';
const PurchasePlatformApiClient = PremiumPurchasePlatformModule.SDK.ApiClient;
export const getRecommendedAddonProductId = async _ref => {
  let {
    httpClient,
    request: {
      domain,
      domainProductType = DEFAULT_DOMAIN_PRODUCT_TYPE
    }
  } = _ref;
  const parsedDomain = parseDomain(domain);
  if (parsedDomain.error || !parsedDomain.tld) {
    throw new Error('Bad domain name');
  }
  const offerings = await PurchasePlatformApiClient.query.getRecommendedProductFamily({
    httpClient,
    request: {
      productTypeId: getDomainAddonsTypeId(domainProductType),
      purchaseContext: {
        params: {
          tld: `.${parsedDomain.tld}`
        }
      }
    }
  });
  return {
    productId: offerings.productFamilyId
  };
};
export const getDomainCycles = async _ref2 => {
  var _allowedCycle$allowed, _allowedCycle$allowed2, _offerings$products, _domainProduct$pricin, _domainProduct$pricin2;
  let {
    httpClient,
    request: {
      domain,
      flowType,
      domainProductType = DEFAULT_DOMAIN_PRODUCT_TYPE
    }
  } = _ref2;
  const {
    getAllowedCycle
  } = await dynamicLoadApiQueries(httpClient);
  const parsedDomain = parseDomain(domain);
  if (parsedDomain.error || !parsedDomain.tld) {
    throw new Error('Bad domain name');
  }
  const [allowedCycle, offerings] = await Promise.all([flowType && getAllowedCycle({
    allowedCycle: {
      domain: parsedDomain.asciiDomain,
      flowType
    }
  }), PurchasePlatformApiClient.query.getPurchaseUserOffering({
    httpClient,
    request: {
      productTypeId: getDomainProductTypeId(domainProductType),
      purchaseContext: {
        params: {
          tld: `.${parsedDomain.tld}`
        }
      }
    }
  })]);
  const maxAllowedCycle = allowedCycle == null || (_allowedCycle$allowed = allowedCycle.allowedCycle) == null ? void 0 : _allowedCycle$allowed.maxCycleAmount;
  const minAllowedCycle = allowedCycle == null || (_allowedCycle$allowed2 = allowedCycle.allowedCycle) == null ? void 0 : _allowedCycle$allowed2.minCycleAmount;
  const domainProduct = (_offerings$products = offerings.products) == null ? void 0 : _offerings$products[0];
  const isUnfulfillableTransferInCycle = count => flowType === FlowType.TRANSFER_IN && !!minAllowedCycle && count !== minAllowedCycle && count < minAllowedCycle * 2;
  if (!(domainProduct != null && domainProduct.productId)) {
    throw new Error("Can't find product");
  }
  if (!domainProduct.pricingDetails) {
    throw new Error("Can't find pricing");
  }
  return {
    currency: (_domainProduct$pricin = domainProduct.pricingDetails) == null || (_domainProduct$pricin = _domainProduct$pricin[0]) == null || (_domainProduct$pricin = _domainProduct$pricin.finalPrice) == null || (_domainProduct$pricin = _domainProduct$pricin.total) == null ? void 0 : _domainProduct$pricin.currency,
    productId: domainProduct.productId,
    cycles: (_domainProduct$pricin2 = domainProduct.pricingDetails) == null || (_domainProduct$pricin2 = _domainProduct$pricin2.filter(pricing => {
      var _pricing$cycle, _pricing$cycle2, _pricing$finalPrice;
      return !!((_pricing$cycle = pricing.cycle) != null && (_pricing$cycle = _pricing$cycle.cycleDuration) != null && _pricing$cycle.unit) && !!((_pricing$cycle2 = pricing.cycle) != null && (_pricing$cycle2 = _pricing$cycle2.cycleDuration) != null && _pricing$cycle2.count) && !!((_pricing$finalPrice = pricing.finalPrice) != null && (_pricing$finalPrice = _pricing$finalPrice.total) != null && _pricing$finalPrice.formattedAmount) && !isUnfulfillableTransferInCycle(pricing.cycle.cycleDuration.count) && (!maxAllowedCycle || pricing.cycle.cycleDuration.count <= maxAllowedCycle);
    })) == null ? void 0 : _domainProduct$pricin2.sort((a, b) => {
      var _a$cycle, _b$cycle;
      return (((_a$cycle = a.cycle) == null || (_a$cycle = _a$cycle.cycleDuration) == null ? void 0 : _a$cycle.count) ?? 0) - (((_b$cycle = b.cycle) == null || (_b$cycle = _b$cycle.cycleDuration) == null ? void 0 : _b$cycle.count) ?? 0);
    }),
    currencySettings: offerings.currencySettings
  };
};
export const getDomainAddonProducts = async _ref3 => {
  var _offerings$products2;
  let {
    httpClient,
    request: {
      domain,
      domainProductType = DEFAULT_DOMAIN_PRODUCT_TYPE
    }
  } = _ref3;
  const parsedDomain = parseDomain(domain);
  if (parsedDomain.error || !parsedDomain.tld) {
    throw new Error('Bad domain name');
  }
  const offerings = await PurchasePlatformApiClient.query.getPurchaseUserOffering({
    httpClient,
    request: {
      productTypeId: getDomainAddonsTypeId(domainProductType),
      purchaseContext: {
        params: {
          tld: `.${parsedDomain.tld}`
        }
      }
    }
  });
  const sorted = (_offerings$products2 = offerings.products) == null || (_offerings$products2 = _offerings$products2.sort((a, b) => {
    var _a$displayProperties, _b$displayProperties;
    return (((_a$displayProperties = a.displayProperties) == null ? void 0 : _a$displayProperties.order) ?? 0) - (((_b$displayProperties = b.displayProperties) == null ? void 0 : _b$displayProperties.order) ?? 0);
  })) == null ? void 0 : _offerings$products2.filter(product => product.productId !== undefined && product.productFamilyId !== undefined && !!AddonProductFamiliesByDomainProductType[domainProductType][product.productFamilyId]);
  return {
    addons: sorted == null ? void 0 : sorted.map(product => ({
      ...product,
      domainAddonFamily: AddonProductFamiliesByDomainProductType[domainProductType][product.productFamilyId]
    }))
  };
};
//# sourceMappingURL=dynamic.js.map